import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/plt/password");

const loginByAccountAsync = (params) => {
    return remoteCall.invoke("loginByAccount", params);
};

const getConfigAsync = (params) => {
    return remoteCall.invoke("getConfig", params);
};

const retrieveAsync = (params) => {
    return remoteCall.invoke("retrieve", params);
};

export default {
    loginByAccountAsync,
    getConfigAsync,
    retrieveAsync,
};
